module.exports = (__parcel__import__("dlepB")).then(() => parcelRequire('4MKVl'));